<template>
    <h4>Etiqueta</h4>
</template>

<script>
    export default{
        name: "BlogEtiqueta",
    }
</script>
